import React, {useEffect} from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from '../routes/PrivateRoute';
import Login from './auth/Login/Login';
import Register from './auth/Register/Register';
import CryptoDashboard from './scenes/CryptoDashboard/CryptoDashboard';
import {Homepage} from './index';
import 'antd/dist/antd.css';
import Cryptocurrencies from './scenes/CryptoCurrencies/CryptoCurrencies';
import StockDashboard from './scenes/StockDashboard/StockDashboard';
import CryptoDetails from './scenes/CryptoDetails/CryptoDetails';
// eslint-disable-next-line
import Chart from 'chart.js/auto';
import StockMarketPlace from './scenes/StockMarketPlace/StockMarketPlace';
import StockDetails from './scenes/StockDetails/StockDetails';
import Footer from './containers/Footer/Footer';
import ForgotPassword from './auth/ForgotPassword/ForgotPassword';
import PasswordChange from './auth/PasswordChange/PasswordChange';
import MyProfile from './auth/MyProfile/MyProfile';
import {isTokenValid, setAuthToken} from '../utils/setAuthToken';
import { useDispatch } from 'react-redux';
import {logout, login} from '../redux/actions/authActions';
import { setCurrentUser } from "../redux/actions/userActions";
import UnAuthRoute from '../routes/UnAuthRoute';
import StockPortfolio from './scenes/StockPortfolio/StockPortfolio';
import MaterialNavbar from './containers/MaterialNavbar/MaterialNavbar';
import StockHowItWorks from './scenes/StockHowItWorks/StockHowItWorks';
import {stockMenu, cryptoMenu} from '../constants/nav-menu';
import '../assets/css/global.css';

const App = () => {
    const dispatch = useDispatch();
    
    // Preserving the login state
    const checkLogin = () => {
        if(localStorage.getItem('authToken')){
            const data = isTokenValid(localStorage.getItem('authToken'));
            if(data.isValid){
                dispatch(login(data.data))
                dispatch(setCurrentUser(JSON.parse(localStorage.getItem('currentUser'))))
                setAuthToken(`Bearer ${localStorage.getItem('authToken')}`)
            }else{
                dispatch(logout())
                setAuthToken()
            }
        }
    }

    useEffect(() => {
       checkLogin();
    } , [])

    return (
        <div>
            <Route path="/" exact component={Homepage} />
            <UnAuthRoute path="/login" exact component={Login} />
            <UnAuthRoute path="/register" exact component={Register} />
            <UnAuthRoute path="/forgot-password" exact component={ForgotPassword} />
            <UnAuthRoute path="/password-change/:resetToken" exact component={PasswordChange} />
            <PrivateRoute path="/my-profile" exact component={MyProfile} />
            <UnAuthRoute path="/crypto/*">
                <div>
                    <MaterialNavbar menu={cryptoMenu} />
                    <div className="content-wrapper">
                        <Switch>
                            <UnAuthRoute path="/crypto/dashboard" exact component={CryptoDashboard} />
                            <UnAuthRoute path="/crypto/currencies" exact component={Cryptocurrencies} />
                            <UnAuthRoute path="/crypto/currencies/:coinid" component={CryptoDetails} />
                            <UnAuthRoute path="/crypto/how-it-works" component={StockHowItWorks} />
                        </Switch>
                    </div>
                </div>
                <Footer />
            </UnAuthRoute>
            <UnAuthRoute path="/stock/*">
                <div>
                    <MaterialNavbar menu={stockMenu} />
                    <div className="content-wrapper">
                        <Switch>
                            <UnAuthRoute path="/stock/dashboard" component={StockDashboard} />
                            <UnAuthRoute path="/stock/marketplace" exact component={StockMarketPlace} />
                            <PrivateRoute path="/stock/portfolio" exact component={StockPortfolio} />
                            <UnAuthRoute path="/stock/details/:ticker" exact component={StockDetails} />
                            <UnAuthRoute path="/stock/how-it-works" component={StockHowItWorks} />
                        </Switch>
                    </div>
                </div>
                <Footer />
            </UnAuthRoute>
        </div>
    )
}

export default App
